import React from 'react';
import '../styles/Wine.css';
import { useInView } from 'react-intersection-observer';
import Bottle from './wineBottle';
import ShopCard from './shopCard';
import { useEffect } from 'react';

const texts = {
  section: {
    en: 'Wine',
    fr: 'Vin',
  },
  block1: {
    title: {
      en: ['Bordeaux region', 'and Côtes de Bourg'],
      fr: ['Les Vins de Bordeaux', 'et des Cotes de Bourg'],
    },
    p1: {
      en: 'The region of Bordeaux has an international reputation of the largest and most prestigious wine producing regions in France.',
      fr: 'La région Bordelaise, de réputation internationale, est la plus vaste et la plus prestigieuse région productrice de vins en France',
    },
    p2: {
      en: 'This vineyard contrasting with varied soils is organized around three river axes: the Garonne, the Dordogne and their common estuary, the Gironde.',
      fr: 'Les vignobles bordelais de sols variés s’étendent autour de l’axe de trois rivières : la Dordogne, la Garonne et leur estuaire mutuel de la Gironde.',
    },
    p3: {
      en: 'The majority of Bordeaux wines (nearly 90 percent of production volume) are the dry, medium- and full-bodied red Bordeaux Blends.',
      fr: 'La majorité des vins de Bordeaux (près de 90 % du volume de production) sont des assemblages bordelais rouges secs, moyennement corsés et corsés.',
    },
    p4: {
      en: 'The diversity and richness of its wines as well as the beauty of its castles make it a popular place.',
      fr: 'La diversité et la richesse de ses vins ainsi que la beauté de ses châteaux en font une région très prisée.',
    },
    p5: {
      en: 'Bordeaux, with its renowned 1855 Classification, is a leading destination for wine lovers, as well as the bedrock of the fine wine market and a benchmark for winemakers around the world.',
      fr: 'Bordeaux, avec son célèbre Classement 1855, est une destination de choix pour les amateurs de vin, ainsi que le socle du marché des vins fins et une référence pour les vignerons du monde entier.',
    },
    p6: {
      en: 'Located on the right bank of the Dordogne and the Garonne, 35 km north of Bordeaux, the vineyard des Côtes de Bourg spreads over 15 municipalities. ',
      fr: 'Les vignobles des Côtes de Bourg situés sur la rive droite de la Dordogne et de la Garonne, à 35 km de Bordeaux, s’étendent sur 15 communes.',
    },
    p7: {
      en: 'Thanks to it hilly typography the The Côtes de Bourg appellation is known locally as "little Gironde Switzerland".',
      fr: 'En raison de ses paysages vallonnés, la région des Côtes de Bourg est aussi connue sous l’appellation de « Petite Gironde Suisse ».',
    },
    p8: {
      en: 'It`s terroir benefits from a temperate oceanic climate and clay-limestone, gravelly and sandy soils. The hillslopes provide good exposure to the sun while close proximity to the masses of water ensures a warmer mesoclimate.',
      fr: 'Ses terroirs tirent parti d’un climat tempéré, de sols argilo-calcaire, rocailleux et sablonneux. Les versants offrent une bonne exposition au soleil tandis que la proximité des masses d’eau assure un micro-climat plus chaud.',
    },
  },
  block2: {
    title: {
      en: ['Our', 'Wines'],
      fr: ['Nos', 'Vins'],
    },
    p1: {
      en: 'We produce 100 000 bottles per year.',
      fr: 'Nous produisons 100000 bouteilles par an',
    },
    p2: {
      en: 'Through the years château belonged to few families who maintained a traditional wine making process.',
      fr: 'Au fil des années, le château a appartenu à quelques familles qui ont maintenu un processus de vinification traditionnel.',
    },
    p3: {
      en: 'The vineyard consists of 19.4 hectares of vines under AOC Cotes de Bourg at AOC Bordeaux.',
      fr: 'Le vignoble de 19.4 hectares produit des vins classés sous l’appellation AOC Côtes de Bourg et AOC Bordeaux.',
    },
    p4: {
      en: 'Our vineyard presents three main grape varieties typical for Bordeaux : 54% Merlot, 25% Malbec and 21% Cabernet Sauvignon. Currently we only produce red wine. Wine is fermented and stored in cement vats. Special cuvee is aged in oak barrels made from French and American oak.',
      fr: 'Notre vignoble produit trois cépages typiques de la région bordelaise : 54% de Merlot, 25% de Malbec, et 21% de Cabernet Sauvignon. En ce moment nous nous concentrons uniquement sur une production de vin rouge.',
    },
    readMore: {
      en: 'READ MORE',
      fr: 'LIRE PLUS'
    }
  }
}

const animate =(inView, animationType, delay, speed)=>{
  const animation = `animate__${animationType}`;
  const animateSpeed = speed ? `animate__${speed}` : '';
  return `animate__animated ${inView ? animation : ''} animate__delay-${delay}s ${animateSpeed}`;
}

const setSection =(section, props, inView)=>{
  if(inView && props.nav !== section){
    props.setNav(section);
  }
}

const RegionSection =(props)=> {
  const section = 'wine';
  const lang = props.lang;
  const { ref, inView } = useInView({threshold: 0.5});
  useEffect(() => {
    setSection(section, props, inView);
  });
  return (
  <div className="container" ref={ref}>

    <div className="section-title">
      <h2 className={animate(inView, 'bounceInDown', 0.2)}>{texts.section[lang]}</h2>
      <h3 className={animate(inView, 'flipInX', 1)}>{texts.block1.title[lang][0]} <span>{texts.block1.title[lang][1]}</span></h3>
      <p className={animate(inView, 'fadeIn', 1, 'slow')}>{texts.block1.p1[lang]}</p>
    </div>

    <div className={`row content ${animate(inView, 'fadeIn', 0, 'slow')}`}>
      <div className="col-lg-6">
        <p>{texts.block1.p2[lang]}</p>
        <p>{texts.block1.p3[lang]}</p>
        <p>{texts.block1.p4[lang]}</p>
        <p>{texts.block1.p5[lang]}</p>
      </div>
      <div className="col-lg-6 pt-4 pt-lg-0">
        <div className='image-wrapper'>
            <img src="/bordeaux.jpg" className="bordeaux-image" alt=""></img>
        </div>
      </div>
    </div>

    <div className={`row content ${animate(inView, 'fadeIn', 0, 'slow')}`}>
      <div className="col-lg-6">
        <div className='image-wrapper'>
            <img src="/cotes-de-bourge.jpg" className="cotes-image" alt=""></img>
        </div>
      </div>
      <div className="col-lg-6 pt-4 pt-lg-0">
        <p>{texts.block1.p6[lang]}</p>
        <p>{texts.block1.p7[lang]}</p>
        <p>{texts.block1.p8[lang]}</p>
      </div>
    </div>

  </div>
  )
}

const WinesSection =(props)=> {
  const lang = props.lang;
  const { ref, inView } = useInView();
  return (
  <div ref={ref} className="container" id="wine2">
    <div className="section-title">
        <h3 className={animate(inView, 'flipInX', 1)}>{texts.block2.title[lang][0]} <span>{texts.block2.title[lang][1]}</span></h3>
        <p className={animate(inView, 'fadeIn', 1, 'slow')}><span>{texts.block2.p1[lang]}</span></p>
    </div>

    <div className={`row content ${animate(inView, 'fadeIn', 0, 'slow')}`}>
        <div className="col-lg-6">
        <p>{texts.block2.p2[lang]}</p>
        <p>{texts.block2.p3[lang]}</p>
        <p>{texts.block2.p4[lang]}</p>
        </div>
        <div className="col-lg-6 pt-4 pt-lg-0">
        <div className='image-wrapper'>
            <img src="/vines-graph.jpg" className="graph-image" alt=""></img>
        </div>
        </div>
    </div>

    <div className="row content wines">
      <ShopCard lang={lang} />
    </div>

  </div>
  )
}

const Wine =(props)=> {
    return (
    <section id="wine" className="wine section">
      <RegionSection lang={props.lang} nav={props.nav} setNav={(section)=>{props.setNav(section)}}/>
      <WinesSection lang={props.lang} nav={props.nav} setNav={(section)=>{props.setNav(section)}}/>
    </section>
  );
}

export default Wine